import React from "react";

function Footer() {
  return (
    <div className="footer">
      Copyright © 2020 "BlogApp" Designed By: <br/>
      <a href="https://github.com/adamjmosebach"> Adam Mosebach | </a>
      <a href="https://github.com/sormiston">Sean Ormiston | </a>
      <a href="https://github.com/Ricomitch">Rico Mitchell | </a>
      <a href="https://github.com/akram185">Waseem Mohammed </a>
    </div>
  );
}

export default Footer;
